<fieldset [disabled]="(!userRole.isAdminRole && !userRole.isSuperAdminRole && !userRole.isTechAdminRole)">
  <scitis-app-global-page-header [pageTitle]="'Traffic light configuration'">
    @if (isSyncTrafficLightSettingsSliderVisible) {
      <ng-template #filterElement>
        <div class="custom-control custom-switch">
          <input (change)="onSyncTrafficLightSettingsChange($event)"
            [checked]="isSyncTrafficLightSettingsChecked"
            [disabled]="isAdminOrLower"
            class="custom-control-input"
            id="syncTrafficLightCheckbox"
            type="checkbox">
            <label class="custom-control-label" for="syncTrafficLightCheckbox">
              <span class="mr-2" translate>Sync traffic light settings</span>
              <span
                [ngbTooltip]="'If this flag is enabled, all needed signals and selected Status event page will be created/updated on target machines'|translate">
                <span class="fa-solid fa-circle-question"></span>
              </span>
            </label>
          </div>
        </ng-template>
      }
    </scitis-app-global-page-header>

    <div class="form-row">
      <div class="col-12">
        <div class="form-group">
          <label for="signal" translate>Select source</label> <br>
          <div class="form-check d-inline-block mr-3">
            <input (click)="setIsUsingSignalAsSource()"
              [checked]="!machine.trafficLightConfiguration.usingStatusEventPage"
              [disabled]="isAdminOrLower"
              class="form-check-input"
              id="radio_signal"
              name="signal" type="radio">
              <label class="form-check-label" for="radio_signal" translate>Signal</label>
            </div>
            <div class="form-check d-inline-block">
              <input (click)="setIsUsingStatusEventPageAsSource()"
                [checked]="machine.trafficLightConfiguration.usingStatusEventPage"
                [disabled]="isAdminOrLower"
                class="form-check-input"
                id="radio_status_page"
                name="statusPage" type="radio">
                <label class="form-check-label" for="radio_status_page" translate>Status Event Page</label>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div class="form-row">
            @if (!machine.trafficLightConfiguration.usingStatusEventPage) {
              <div class="col-12 col-lg-6">
                <div class="form-group">
                  <label for="signal" translate>Signals</label>
                  @if (isLoadingSignals) {
                    <span class="fa-solid fa-spinner fa-spin"></span>
                    } <br>
                    <ng-select (change)="onSelectSignal($event)"
                      [(ngModel)]="machine.trafficLightConfiguration.signalId"
                      [clearable]="true"
                      [items]="signalsArray"
                      [notFoundText]="signalNotFoundText"
                      [placeholder]="signalsPlaceholderText"
                      [searchable]="true"
                      [title]="signalsPlaceholderText"
                      [disabled]="isAdminOrLower"
                      bindLabel="label"
                      bindValue="id"
                      id="signal" name="signal">
                      <ng-template let-item="item" ng-label-tmp>
                        <span [innerText]="item.label | translate"></span>
                      </ng-template>
                      <ng-template let-item="item" ng-option-tmp>
                        <div><span [innerText]="item.label | translate"></span></div>
                        @if (item.name) {
                          <small [innerText]="item.name"></small>
                        }
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
              }
              <div class="col-12 col-lg-6">
                <div class="form-group">
                  <label for="statusPage" translate>Status event pages</label>
                  @if (isLoadingStatusEventPages) {
                    <span class="fa-solid fa-spinner fa-spin"></span>
                    }<br>
                    <ng-select (change)="onSelectStatusEventPage($event)"
                      [(ngModel)]="machine.trafficLightConfiguration.statusEventPageId"
                      [clearable]="true"
                      [items]="statusEventPagesArray"
                      [notFoundText]="statusEventPageNotFoundText"
                      [placeholder]="statusEventPagePlaceholderText"
                      [searchable]="true"
                      [title]="statusEventPagePlaceholderText"
                      [disabled]="isAdminOrLower"
                      bindLabel="name"
                      bindValue="id"
                      id="statusPage" name="statusPage">
                      <ng-template let-item="item" ng-option-tmp>
                        <div><span [innerText]="item.name"></span></div>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
              </div>

              <div class="divider"></div>

              @if (!machine.trafficLightConfiguration.usingStatusEventPage) {
                <div class="row">
                  <div class="col-12 col-lg-4">
                    <scitis-admin-traffic-light-element [config]="machine.trafficLightConfiguration.running"
                      [isHigherThanAdmin]="userRole.isSuperAdminRole || userRole.isTechAdminRole"
                    [kind]="'RUNNING'"></scitis-admin-traffic-light-element>
                  </div>
                  <div class="col-12 col-lg-4">
                    <scitis-admin-traffic-light-element [config]="machine.trafficLightConfiguration.warning"
                      [isHigherThanAdmin]="userRole.isSuperAdminRole || userRole.isTechAdminRole"
                    [kind]="'WARNING'"></scitis-admin-traffic-light-element>
                  </div>
                  <div class="col-12 col-lg-4">
                    <scitis-admin-traffic-light-element [config]="machine.trafficLightConfiguration.failure"
                      [isHigherThanAdmin]="userRole.isSuperAdminRole || userRole.isTechAdminRole"
                    [kind]="'FAILURE'"></scitis-admin-traffic-light-element>
                  </div>
                </div>
              }

              @if (!machine.trafficLightConfiguration.usingStatusEventPage) {
                <div class="divider"></div>
              }
            </div>

            @if (shouldShowSaveButton) {
              <button (click)="onSaveTrafficLightConfiguration()"
                [disabled]="isLoadingSignals || isLoadingStatusEventPages"
                class="btn btn-primary btn-lg btn-save" translate>Save
              </button>
            }
          </fieldset>
